import React, { useState } from 'react';
import { Form, Button, Container, Card, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { encryptPassword } from '../utils/auth';

const Register = () => {
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        cpf: '',
        matricula: '',
        senha: '',
        perfil: 'Gestor de Treinamento'
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const payload = { ...formData, senha: encryptPassword(formData.senha) };
            await api.post('/register', payload);
            navigate('/login');
        } catch (err) {
            setError('Erro ao cadastrar. Verifique os dados.');
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Card style={{ width: '500px' }}>
                <Card.Body>
                    <h2 className="text-center mb-4">Cadastro - Confirma AI</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleRegister}>
                        <Form.Group className="mb-2">
                            <Form.Label>Nome Completo</Form.Label>
                            <Form.Control type="text" onChange={(e) => setFormData({...formData, nome: e.target.value})} required />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Email Corporativo</Form.Label>
                            <Form.Control type="email" onChange={(e) => setFormData({...formData, email: e.target.value})} required />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>CPF</Form.Label>
                            <Form.Control type="text" placeholder="000.000.000-00" onChange={(e) => setFormData({...formData, cpf: e.target.value})} required />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Matrícula (PIN)</Form.Label>
                            <Form.Control type="text" onChange={(e) => setFormData({...formData, matricula: e.target.value})} required />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control type="password" onChange={(e) => setFormData({...formData, senha: e.target.value})} required />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Perfil</Form.Label>
                            <Form.Select onChange={(e) => setFormData({...formData, perfil: e.target.value})}>
                                <option value="Gestor">Gestor de Treinamento</option>
                                <option value="Administrador">Administrador</option>
                            </Form.Select>
                        </Form.Group>
                        <Button className="w-100" type="submit">Cadastrar</Button>
                    </Form>
                    <div className="text-center mt-3">
                        Já tem conta? <Link to="/login">Login</Link>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Register;
